import { toJS } from 'mobx';
import { UserType } from 'typings/old-types/UserType';

import { ROUTER } from 'src/constants';
import { form, sessionStore } from 'src/stores';
import { history, fireToast, validation, t } from 'src/utils';

import { MORE_INFO_FORM_ID } from '../../constants';

import { mapper, moreInfoFormData } from '../../utils/mapperMiddleware';

import { userProfile } from '../../services';

import { moreInfoValidation } from '../../validation';

export const updateUserProfile = async () => {
  const formData = toJS(moreInfoFormData());
  const mappedUser = mapper.mapTo(formData);
  const validateData = mapper.mapToValidation(mappedUser);

  const isValid = validation(MORE_INFO_FORM_ID, validateData, moreInfoValidation);

  if (isValid) {
    const [status, response] = await userProfile.submitProfile(mappedUser as UserType);

    if (!status) {
      fireToast(t.staticAsString('toast.error.text'), 'error', '', 'top-right');
      return;
    }

    const user = response.data;
    sessionStore.userProfile(user);
    form.merge(MORE_INFO_FORM_ID, {
      ...mapper.mapFrom(user),
    });

    history.push(ROUTER.PROFILE);
    fireToast(t.staticAsString('toast.profileUpdated') as any, 'success', '', 'top-right');
  } else {
    fireToast(t.staticAsString('toast.error.text'), 'error', '', 'top-right');
  }
};
